import React, { useState, useCallback } from 'react';
import { Col } from 'react-bootstrap';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import AffiliationsAwardsTab from './AffiliationsAwardsTab';
import ProviderInformationTab from './ProviderInformationTab';
import { t } from 'i18next';

const RightSection = ({
  locationHandler,
  affiliatedDoctorsHandler,
  doctorDetails,
  addressIndex,
  affiliatedDoctorsAddress,
}) => {
  const [selectedTab, setSelectedTab] = useState('provider-information');

  const selectAwardsTab = useCallback(() => {
    setSelectedTab('awards-recognitions');
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });

  return (
    <>
      <Col sm={9}>
        <div className="details-section secondary-background">
          <div className="tabs-section">
            <Tabs defaultTab={selectedTab}>
              <TabList>
                <Tab
                  onClick={() => setSelectedTab('provider-information')}
                  tabFor="provider-information"
                >
                  {t('find_provider.provider_information')}
                </Tab>
                <Tab
                  onClick={() => setSelectedTab('awards-recognitions')}
                  tabFor="awards-recognitions"
                >
                  {t('find_provider.affiliations')},{' '}
                  {t('find_provider.awards_and_recognitions')}
                </Tab>
              </TabList>
              <TabPanel tabId="provider-information">
                <ProviderInformationTab
                  locationHandler={locationHandler}
                  doctorDetails={doctorDetails}
                  addressIndex={addressIndex}
                  selectAffiliationsTab={selectAwardsTab}
                  affiliatedDoctorsAddress={affiliatedDoctorsAddress}
                />
              </TabPanel>
              <TabPanel tabId="awards-recognitions">
                <AffiliationsAwardsTab
                  affiliatedDoctorsHandler={affiliatedDoctorsHandler}
                  doctorDetails={doctorDetails}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </Col>
    </>
  );
};
export default RightSection;
